import React from 'react'
import './LGrid.css'
import {luiClassName} from "../../utils/lui"
import PropTypes from "prop-types"


/**
 *  LGrid
 *
 *  @param {*} children
 *  @param {string|undefined} className
 *  @param {*|CSSProperties|undefined} style
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function LGrid({ children, className, style }){

    className = luiClassName([
        '-LGrid',
        className
    ])

    return (
        <div className={className} style={style}>{children}</div>
    )

}

LGrid.propType = {
    children:   PropTypes.any,
    className:  PropTypes.string,
    style:      PropTypes.objectOf('CSSProperties')
}